import { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery, createTheme, ThemeProvider} from '@mui/material';
import * as CommonSectionTypes from './CommonSectionTypes';
import * as CommonSectionProps from './CommonSectionProps';

const CommonSectionGenerator = (
  sectionData: CommonSectionTypes.Section,
  CustomButton: React.FC<CommonSectionTypes.StartCreatingButtonProps>,
  background: string) =>
{
  const theme = createTheme(
    {
      typography:
      {
        fontFamily: "Inter", // Change the default font-family            
      }
    }
  );

  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() =>
  {
    const interval = setInterval(() =>
    {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % sectionData.subsections[0].images.length);
    }, 4000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <>
      <ThemeProvider theme={theme}>    
        <Box id="slp-influencers-why" sx={[CommonSectionProps.sectionBoxProps(), {background: background}]}>
          {/* Section Header */}
          <Box sx={CommonSectionProps.sectionHeadingBoxProps(theme)}>
            {/* Section Heading */}
            <Typography variant="h4" sx={CommonSectionProps.sectionHeadingProps()}>
              {sectionData.heading}
            </Typography>
            {/* Section Subheading */}
            <Typography variant="h4" sx={CommonSectionProps.sectionSubHeadingProps()}>
              {sectionData.subheading}
            </Typography>
          </Box>

          {/* Subsections */}
          <Box sx={CommonSectionProps.subsectionBoxProps(theme)}>
            {sectionData.subsections.map((subsection, index) =>
            {
              const isEven = index % 2 === 0;
              const currentImage = subsection.images[currentImageIndex];

              return (
                <Box key={index} sx={[CommonSectionProps.subSectionHeadingBoxProps(theme), {flexDirection: isEven ? 'row' : 'row-reverse'}]}>
                  {/* Subsection Heading for Mobile */}
                  <Typography variant="h5" sx={CommonSectionProps.subSectionHeadingPropsMobile()}>
                    {subsection.heading}
                  </Typography>

                  {/* Subsection Image */}
                  <Box sx={{ flex: 2, backgroundColor: '#000000' }}>
                    <Box
                      component="img"
                      src={currentImage}
                      alt="Creator Image"
                      sx={CommonSectionProps.subSectionImageBoxProps()}
                    />
                  </Box>

                  <Box sx={CommonSectionProps.subSectionContentBoxProps()}>
                    {/* Subsection Heading for Desktop */}
                    <Typography variant="h5" sx={CommonSectionProps.subSectionHeadingProps(theme)}>
                      {subsection.heading}
                    </Typography>
                    
                    {/* Subsection Description for Desktop */}
                    <Typography variant="h5" sx={CommonSectionProps.subSectionDescriptionProps()}>
                      {subsection.description}
                    </Typography>
                  </Box>              

                  {/* Subsection Description for Mobile */}
                  <Typography variant="h5" sx={CommonSectionProps.subSectionDescriptionPropsMobile()}>
                    {subsection.description}
                  </Typography>
                </Box>
              );
            })}
          </Box>
          {/* Footer Text */}
          <Box sx={CommonSectionProps.footerBoxProps(theme)}>
            <CustomButton
              maxWidth={isMdOrBelow ? '131px' : '200px'}
              maxHeight={isMdOrBelow ? '49px' : '52px'}
              fontSize={isMdOrBelow ? '14px' : '16px'}
              padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
            />
          </Box>        
        </Box>
      </ThemeProvider>
    </>  
  );
};

export default CommonSectionGenerator;
